import { singleLineString } from '../../../functions/misc.functions';

export interface FetchXmlQuery {
    entity: string;
    query: string;
}
export interface FetchXmlParams {
    [key: string]: string | string[];
}

export const getFetchXmlQuery = (query: FetchXmlQuery, params: FetchXmlParams = {}) => {
    const composedQuery = singleLineString(
        `${query.query}`.replace(/##(\w+)##/g, (match, name) => {
            const value = params[name];

            if (Array.isArray(value)) {
                return value.map((val) => `<value>${val}</value>`).join('');
            }
            return typeof value !== 'undefined' ? value : match;
        }),
    );
    return {
        entity: query.entity,
        fetchxml: composedQuery,
    };
};
